// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase:{
    apiKey: "AIzaSyD9Di4CP4dce_qMacvhJ0ymtXPNcIDYM4A",
    authDomain: "ciberi.firebaseapp.com",
    databaseURL: "https://ciberi.firebaseio.com",
    projectId: "ciberi",
    storageBucket: "ciberi.appspot.com",
    messagingSenderId: "588081839106",
    appId: "1:588081839106:web:1a9a11a987c9421c0c7b1b",
    measurementId: "G-CL4TVXMREY"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
